/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "theme-ui";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useHashLocation from "../../use-hash-location";

import ModalWithPortal from "./ModalWithPortal";
import Logo from "./HeaderBar/Logo";
import whiteList from "../../data/whiteList";

const CallToAction = () => {
  const [isOpenPortal, setIsOpenPortal] = useState(false);
  const { t } = useTranslation();
  const [location, setLocation] = useHashLocation();

  const handleOpenPortal = () => {
    setIsOpenPortal(true);
  };

  const handleExit = () => {
    let target = location;
    const parts = target.split("/");
    if (parts[parts.length - 1] === "cta") {
      parts.pop();
      target = parts.join("/") || "";
    } else {
      // fallback: remove any /cta occurrences
      target = target.replace(/\/cta/g, "");
    }
    setLocation(target);
    setIsOpenPortal(false);
  };

  useEffect(() => {
    if (location.includes("cta")) {
      setIsOpenPortal(true);
    }
  }, [location]);

  const buttonStyle = {
    backgroundColor: "#37a46e",
    color: "#000000",
    outline: "none",
    border: "none",
    width: "100%",
    p: ".55vw 0",
    borderRadius: "7px",
    boxShadow: "0px 0px 10px rgba(0,0,0,0.15)",
    fontSize: "0.7vw",
    letterSpacing: "1px",
    textTransform: "uppercase",
    fontWeight: "600",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#5cd89a",
      boxShadow: "0px 0px 10px rgba(0,0,0,0.25)",
    },
  };

  return (
    <>
      {/* <div
        style={{
          position: "absolute",
          top: 0,
          right: "10vw",
          color: "white",
          cursor: "pointer",
          padding: "1vw",
        }}
        onClick={() => {
          handleOpenPortal();
          setLocation(`${location}/cta`);
        }}
      >
        CallToAction
      </div> */}

      <ModalWithPortal
        isOpenPortal={isOpenPortal}
        setIsOpenPortal={() => setIsOpenPortal(false)}
        setLocation={() => setLocation(`${location.replace("/cta", "")}`)}
      >
        <div
          sx={{
            background: "#fff",
            width: ["50vw", "50vw", "25vw"],
            padding: "1.5vw",
            paddingBottom: "2vw",
            zIndex: "99999999999999999999999999999999",
          }}
        >
          <div
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                width: "100%",
              }}
            >
              <span
                style={{
                  cursor: "pointer",
                  color: "#000",
                }}
                onClick={() => {
                  handleExit();
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="10.471" height="10.471" viewBox="0 0 10.471 10.471">
                  <g id="Group_6084" data-name="Group 6084" transform="translate(-1161.87 -393.729)">
                    <path
                      id="Path_10326"
                      data-name="Path 10326"
                      d="M5118.577-21688.564l9.057,9.057"
                      transform="translate(-3956 22083)"
                      fill="none"
                      stroke="#000"
                      strokeWidth="2"
                    />
                    <path
                      id="Path_10327"
                      data-name="Path 10327"
                      d="M5127.634-21688.564l-9.057,9.057"
                      transform="translate(-3956 22083)"
                      fill="none"
                      stroke="#000"
                      strokeWidth="2"
                    />
                  </g>
                </svg>
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "100%",
                marginBottom: "1.5vw",
              }}
            >
              <Logo logoBlack />

              <p style={{ fontSize: "0.85vw" }}>{t("POPUP_ACCESS_DENIED_HEADLINE")}</p>
            </div>

            <div
              style={{
                flexDirection: "column",
                width: "100%",
                marginBottom: "1.5vw",
                fontSize: "0.8vw",

                color: "#707070",
              }}
            >
              <p>{t("POPUP_ACCESS_DENIED_TEXT_1")}</p>
            </div>
            <div
              style={{
                flexDirection: "column",
                width: "100%",
                marginBottom: "1.5vw",
                fontSize: "0.8vw",

                color: "#707070",
              }}
            >
              <p>{t("POPUP_ACCESS_DENIED_TEXT_2")}</p>
            </div>

            <button sx={buttonStyle}>
              <a
                sx={{
                  textDecoration: "none",
                  color: "#000",
                  width: "100%",
                  display: "block",
                }}
                href={t("BUTTON_GET_IN_TOUCH_URL")}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("BUTTON_GET_IN_TOUCH")}
              </a>
            </button>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <p style={{ fontSize: "0.85vw" }}>{t("POPUP_ACCESS_DENIED_SIGNIN_HEADLINE")}</p>

              <button
                // sx={{
                //   background: "#000",
                //   width: "100%",
                //   color: "#fff",
                //   p: ".75vw 0",
                //   fontSize: "0.9vw",
                //   cursor: "pointer",
                // }}
                sx={buttonStyle}
                onClick={() => {
                  setIsOpenPortal(false);
                  setLocation(`${location.replace("/cta", "/login")}`);
                }}
              >
                {t("BUTTON_LOGIN")}
              </button>
            </div>
          </div>
        </div>
      </ModalWithPortal>
    </>
  );
};

export default CallToAction;
